<template>
    <el-form
        ref="form"
        :model="form"
        :rules="rules"
        v-loading="isBusy"
        element-loading-spinner="el-icon-loading"
        label-width="250"
    >
        <el-form-item label="Brand" prop="brand_id">
            <el-select
                    class="w-100"
                    placeholder="Brand"
                    v-model="form.brand_id"
            >
                <el-option
                        v-for="option in brandOptions"
                        :key="option.value"
                        :label="option.label"
                        :value="option.value"
                ></el-option>
            </el-select>
        </el-form-item>
        <div class="text-muted small mb-3">
            <div><strong>File format:</strong> CSV, one phone number per line, no header row.</div>
            <ul class="pl-3 mb-0">
                <li>Only the first column is read, any other columns are ignored.</li>
                <li>Accepted: (803) 518-2700, 803-518-2700, 8035182700, +18035182700.</li>
                <li>Numbers are read as US unless they start with +.</li>
                <li>Every line is reported in the import log: created, unchanged or invalid.</li>
            </ul>
        </div>
        <el-form-item label="Import File:" prop="file">
            <div v-if="isFileSelected">
                <em>{{ this.fileInfo }}</em>
                <span class="btn btn-link btn-link-red px-1" @click="clearFile"><i class="fas fa-times-circle"></i></span>
            </div>
            <file-input v-else v-model="form.file" v-slot:default="{clickHandler}">
                <span @click.prevent="clickHandler" class="btn btn-link btn-link-purple px-0"><i class="fas fa-folder-open"></i></span>
            </file-input>
        </el-form-item>
        <el-form-item>
            <button class="btn btn-purple" @click.prevent="store" :disabled="!isFileSelected">Process</button>
        </el-form-item>
    </el-form>
</template>

<script>
  import BaseImportForm from './base-import-form';

  export default {
    extends: BaseImportForm,

    props: {
      brandOptions: Array,
    },

    data() {
      return {
        form: {
          brand_id: null,
          file: null,
        },
        rules: {
          brand_id: [{validator: this.fieldExternalValidator}],
          file: [{validator: this.fieldExternalValidator}],
        },
      };
    },

    methods: {
      /**
       * @param {Object} model
       */
      initForm({brand_id = null, file = null}) {
        this.form = {brand_id, file};
      },
    },
  }
</script>
